// ** React Imports
import React, {Fragment, useEffect} from 'react'

// ** Reactstrap Imports
import {
    Row,
    Col,
    Card,
    Input,
    Label,
    CardTitle,
    CardHeader, Button
} from 'reactstrap'

// ** Styles
import '@styles/react/libs/tables/react-dataTable-component.scss'
import { getSocieties } from './thunks'
import { useDispatch } from 'react-redux'
import SocietiesTable from './components/SocietiesTable'

const SocietiesList = () => {

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getSocieties("socied"))
    }, []);

    return (
        <Fragment>
            <Card>
                <CardHeader className='flex-md-row flex-column align-md-items-center align-items-start border-bottom'>
                    <CardTitle tag='h4'>Sociedades</CardTitle>
                </CardHeader>
            </Card>
            <Card>
                <SocietiesTable />
            </Card>
        </Fragment>
    )
}

export default SocietiesList
